/**
 * Debug assertion, will be a noop in production builds.
 */
var debugAssert = function debugAssert(cond, msg) {
  if (process.env.NODE_ENV !== "production" && !cond) {
    throw new Error("Assertion failed: " + msg);
  }
};

export { debugAssert };
//# sourceMappingURL=assert.js.map
